import * as types from '../actions/PlanAnnotationActionTypes';
import { assign } from '../../../shared/Assign';

export default function planOrderReducer(state: any = {}, action: { type: string; result: any }) {
    switch (action.type) {
        case types.GET_PLACEMENTS_SUCCESS: {
            const newState = assign({}, state);
            newState.placements = action.result;
            return newState;
        }

        default:
            return state;
    }
}
